import React, { useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { ORACLE_TEST_IDS } from "@/constants/oracle";

export default function ChatPanel({ messages, loading, mode, error }) {
  const endRef = useRef(null);
  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, [messages, loading]);

  return (
    <div className="oracle-chat">
      {messages.length === 0 && !loading && (
        <div className="oracle-empty">
          <div className="oracle-empty__title">The ORACLE is ready.</div>
          <div className="oracle-empty__sub">
            Pick a Quick Pick above, click a sample prompt, or ask the {mode.toUpperCase()} ORACLE
            anything in scope.
          </div>
        </div>
      )}
      {messages.map((m, i) => (
        <div
          key={i}
          className={`oracle-msg oracle-msg--${m.role}`}
          data-testid={m.role === "assistant" ? ORACLE_TEST_IDS.assistantMsg : ORACLE_TEST_IDS.userMsg}
        >
          <div className="oracle-msg__avatar" aria-hidden="true">
            {m.role === "assistant" ? "🔮" : "👤"}
          </div>
          <div className="oracle-msg__bubble">
            {m.role === "assistant" ? (
              <div className="oracle-markdown">
                <ReactMarkdown remarkPlugins={[remarkGfm]}>{m.content}</ReactMarkdown>
              </div>
            ) : (
              <div className="oracle-user-text">{m.content}</div>
            )}
          </div>
        </div>
      ))}
      {loading && (
        <div className="oracle-msg oracle-msg--assistant" data-testid={ORACLE_TEST_IDS.thinking}>
          <div className="oracle-msg__avatar" aria-hidden="true">🔮</div>
          <div className="oracle-msg__bubble">
            <div className="oracle-thinking">
              <span>THE ORACLE IS THINKING</span>
              <span className="dot" />
              <span className="dot" />
              <span className="dot" />
            </div>
            <div className="oracle-progress"><span /></div>
          </div>
        </div>
      )}
      {error && (
        <div className="oracle-error">
          <strong>ORACLE ERROR:</strong> {error}
        </div>
      )}
      <div ref={endRef} />
    </div>
  );
}
